export default function LoadingPage() {
	return (
		<div className="loading-container">
			<div className="loading-text">
				<span>g</span>
				<span>i</span>
				<span>v</span>
				<span>a</span>
				<span>t</span>
				<span>a</span>
				<span>k</span>
				<span>e</span>
			</div>
		</div>
	);
}
